import React from 'react';
import {
	Modal,
} from 'react-bootstrap';
import {
	func,
	bool,
	node
} from 'prop-types';

import ContainedButton from '../../atoms/ContainedButton/index';
import TextButton from '../../atoms/TextButton/index';
import '../../../i18n';
import { withNamespaces } from 'react-i18next';
import {RowCounter} from '../../molecules/TextInput';
import CreateQuizPreview from '../../molecules/CreateQuizPreview/index';
import AnswerOptionEditor from '../AnswerOptionEditor/index';
import { QuizEditorPresenter } from '../../molecules/Editor/index';
import style from './style';

const Presenter = ({
	isEdit,
	show,
	showHelp,
	toggleShowHelp,
	editorProps,
	previewProps,
	expanderProps,
	optionProps,
	onHide,
	onSave,
	isSample,
	explanation,
	onChangeExplanation,
	onCheckSample,
	t
}) => {
	return <Modal
		show={show}
		onHide={onHide}
		bsSize="large">
		<Modal.Header closeButton>
			<style.Header>
				<h3>{isEdit ? 
					t('create-quiz-modal.UpdateQuiz'):
					t('create-quiz-modal.CreateNewQuiz')}
				</h3>
			</style.Header>
		</Modal.Header>
		<Modal.Body>
			<style.BodyWrapper>
				<style.EditorWrapper>
					{showHelp && (
						<style.Help onClose={toggleShowHelp(false)}/>
					)}
					<QuizEditorPresenter {...editorProps} />
					<style.Hr />
					<style.PreviewFlexBox>
						<CreateQuizPreview  {...previewProps} />
					</style.PreviewFlexBox>
					<h4>{t('create-quiz-modal.Explanation')}</h4>
					<style.ExplanationWrapper>
						<RowCounter 
							maxRows={20}
							minRows={2}
							onChange={onChangeExplanation}
							render={({onChange,ref,rows})=>{
								return (
									<style.Explanation 
										ref={ref}
										rows={rows}
										value={explanation} 
										onChange={onChange} 
										placeholder={'🖋 ' + t('create-quiz-modal.EditExplanation')}
									/>
								);
							}}
						/>
					</style.ExplanationWrapper>
					<style.Hr />
					{expanderProps.enableAnswerOption ?
						<div>
							<style.mobile.AnswerOptionHeader>
								<style.mobile.ShowAnswerButton onClick={expanderProps.onClickClose} >
									<style.mobile.MenuDownIcon />
									{t('create-quiz-modal.EditAnswerOption')}
								</style.mobile.ShowAnswerButton>
							</style.mobile.AnswerOptionHeader>
							{optionProps ? <AnswerOptionEditor {...optionProps} /> :
								<style.DisableBackground> {t('create-quiz-modal.NoAnswerIsRegistered')}</style.DisableBackground>}
						</div> :
						<style.mobile.ShowAnswerButton onClick={expanderProps.onClickExpand} >
							<style.mobile.MenuRightIcon />
							{t('create-quiz-modal.EditAnswerOption')}
						</style.mobile.ShowAnswerButton>
					}
				</style.EditorWrapper>
			</style.BodyWrapper>
		</Modal.Body>
		<Modal.Footer>
			<style.Footer>
				<style.Checkbox checked={isSample} onCheck={onCheckSample}>{t('create-quiz-modal.SaveAsSample')}</style.Checkbox>
				<div>
					<ContainedButton onClick={onSave}>Save</ContainedButton>
					<TextButton onClick={onHide}>Cancel</TextButton>
				</div>
			</style.Footer>
		</Modal.Footer>
	</Modal>;
};

Presenter.propTypes = {
	isEdit: bool,
	show: bool,
	editorPresenter: node,
	previewPrsenter: node,
	optionPresenter: node,
	onHide: func.isRequired,
	onSave: func.isRequired,
	isSample: bool.isRequired,
	onCheckSample: func.isRequired,
};

export default withNamespaces()(Presenter);